import { type LoggedUserDTO, UserManagment } from '@justomx/webview-commons'
import type { Country } from '../../internal-types/country.type'
import { isProduction } from '../../utils/environment'

const REDIRECT_URLS = {
  production: 'https://atlas-web.pages.dev/picking',
  staging: 'https://staging.atlas-web.pages.dev/picking'
}

export const saveAndRedirectService = async ({
  value,
  country,
  goToMenu
}: {
  value: LoggedUserDTO
  country: Country
  goToMenu: () => void
}): Promise<boolean> => {
  UserManagment.setCurrentUser({
    ...value,
    country: value.country.toLowerCase(),
    printerBluetoothLocation: ''
  })
  console.info('saveAndRedirectService', value.menuItems)
  if (!value.menuItems || !value.menuItems.length) {
    if (isProduction()) {
      window.location.href =
        REDIRECT_URLS.production + '?userFrom=getUserInfo&country=' + country
    } else {
      window.location.href =
        REDIRECT_URLS.staging + '?userFrom=getUserInfo&country=' + country
    }
    return false
  }

  if ('_justoPluginCurrentUser' in window && window._justoPluginCurrentUser) {
    console.info(
      'Usuario logueado con éxito! Ahora puedes ingresar a otros sitios.'
    )
  } else {
    console.info('Usuario logueado con éxito!')
  }
  goToMenu()
  return true
}
